var $67e9091dbf37d4eb$exports = {};
$67e9091dbf37d4eb$exports = {
  "calendar": "\uB2EC\uB825",
  "day": "\uC77C",
  "dayPeriod": "\uC624\uC804/\uC624\uD6C4",
  "endDate": "\uC885\uB8CC\uC77C",
  "era": "\uC5F0\uD638",
  "hour": "\uC2DC",
  "minute": "\uBD84",
  "month": "\uC6D4",
  "second": "\uCD08",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "\uC120\uD0DD \uC77C\uC790: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "\uC120\uD0DD \uBC94\uC704: ".concat(args.startDate, " ~ ").concat(args.endDate);
  },
  "selectedTimeDescription": function selectedTimeDescription(args) {
    return "\uC120\uD0DD \uC2DC\uAC04: ".concat(args.time);
  },
  "startDate": "\uC2DC\uC791\uC77C",
  "timeZoneName": "\uC2DC\uAC04\uB300",
  "weekday": "\uC694\uC77C",
  "year": "\uB144"
};
export { $67e9091dbf37d4eb$exports as default };